var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaestroColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "maestro-color"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "card_bg",
    width: 24,
    height: 16,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "maestro"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.01
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 2.32,
    y: 1.6,
    width: 19.35,
    height: 12.8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    x: 9.45,
    y: 3.83,
    width: 5.11,
    height: 8.34,
    fill: "#7272B5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M10 8C9.99454 6.37744 10.7312 4.84142 12 3.83C9.82641 2.12488 6.70762 2.37532 4.83398 4.40545C2.96034 6.43558 2.96034 9.56442 4.83398 11.5945C6.70762 13.6247 9.82641 13.8751 12 12.17C10.7289 11.1605 9.99157 9.62323 10 8Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.41 11.08V11.29H20.3V11.23L20.36 11.08H20.41ZM20.2786 11.1764L20.3 11.23V11.13L20.2786 11.1764ZM20.24 11.08L20.2786 11.1764L20.24 11.26L20.18 11.13V11.08H20.24ZM20.07 11.12V11.29H20V11.12H20.07Z",
    fill: "#00A1DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M20.58 8C20.5748 10.0279 19.415 11.8757 17.5911 12.7622C15.7672 13.6486 13.5977 13.4188 12 12.17C13.2772 11.1631 14.0226 9.6264 14.0226 8C14.0226 6.3736 13.2772 4.8369 12 3.83C13.5957 2.57278 15.7696 2.33829 17.5968 3.22629C19.4239 4.11429 20.5826 5.96853 20.58 8Z",
    fill: "#00A1DE"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaestroColor);
export default __webpack_public_path__ + "static/media/maestro-color.22a7e5f6.svg";
export { ForwardRef as ReactComponent };